<div class="edit-report-wrapper mat-elevation-z1">
  <form [formGroup]="form">
    <h1>Thermal Analysis Report</h1>
    <div class="form-wrapper">

      <!-- Submittal Date -->
      <div class="col-2 b1">
        <mat-label class="mat-label">Submittal Date</mat-label>
        <mat-form-field appearance="outline">
          <input
            class="mat-date-input"
            readonly
            matInput
            formControlName="reportDate"
            [matDatepicker]="picker"
            [min]="today"
            />
            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
        </div>

        <!-- Address To -->
        <div class="col-2 online-type b2">
          <mat-label class="mat-label">Address To</mat-label>
          <mat-form-field appearance="outline" class="mat-form-field-width">
            <mat-select disableOptionCentering formControlName="isBilling" placeholder="Select">
              <mat-option [value]="false">Company</mat-option>
              <mat-option [value]="true">Billing</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <!-- Main Body -->
        <div class="col-11 b3">
          <mat-label class="mat-label">Main Body</mat-label>
          <div class="c-w">
            <app-richtext-editor formControlName="mainBody" minHeight="200px"></app-richtext-editor>
          </div>
        </div>

        <!-- Precast Sample Table -->
        <div class="col-11 b3">
          <mat-label class="mat-label">Precast Sample Table</mat-label>
          <div class="redittable-sample-wrapper">
            <table>
              <tr>
                <th rowspan="2" class="sample-id-col"><span>Sample ID</span></th>
                <th rowspan="2" class="cast-date-col"><span>Cast Date</span></th>
                <th rowspan="2" class="description-col">
                  <span>Material Type</span>
                  <span class="company-name-wrapper">
                    (<input
                    class="editable-cell company-name-input"
                    type="text"
                    formControlName="companyName"
                    placeholder="Company"
                    />)
                  </span>
                </th>
                <th rowspan="2" class="mix-id-col"><span>Mix ID</span></th>
                <th rowspan="2" class="mc">
                  <span>Moisture Content</span><span>(%) </span>
                </th>
                <th rowspan="2" class="dry-density">
                  <span>Dry Density</span>
                  @if (!metricUnitValue) {
                    <span>(lb/ft³) </span>
                  }
                  @if (metricUnitValue) {
                    <span>(Kg/m³)</span>
                  }
                </th>
                <th colspan="2" class="thermal-res">
                  <span>Thermal Resistivity</span>
                  @if (!metricUnitValue) {
                    <span>(°C-cm/W)</span>
                  }
                  @if (metricUnitValue) {
                    <span>(°K.m/W)</span>
                  }
                </th>
              </tr>
              <tr class="b">
                <th class="c"><span>Wet</span></th>
                <th class="c"><span>Dry</span></th>
              </tr>

              @for (thermalData of thermalDataArray.controls; track thermalData; let i = $index) {
                <tr [formGroup]="$any(thermalData)">
                  <td class="sample-id-cell"><input class="editable-cell" type="text" formControlName="sampleId" /></td>
                  <td class="cast-date-cell">{{ formatCastDate($safeNavigationMigration(thermalData.get('castDate')?.value)) }}</td>
                  <td class="description-cell">{{ thermalData.get('materialType')?.value }}</td>
                  <td class="mix-id-cell">
                    @if (thermalData.get('mixID')?.value) {
                      <a
                        class="mix-id-link"
                        target="_blank"
                        rel="noopener"
                      [href]="mixDesignLink($safeNavigationMigration(thermalData.get('mixID')?.value), $safeNavigationMigration(thermalData.get('mixReference')?.value))">{{ thermalData.get('mixID')?.value }}</a>
                    }
                  </td>
                  <td>{{ thermalData.get('moistureContent')?.value }}</td>
                  <td>{{ thermalData.get('dryDensity')?.value }}</td>
                  <td>{{ thermalData.get('wet')?.value }}</td>
                  <td>{{ thermalData.get('dry')?.value }}</td>
                </tr>
              }
            </table>
          </div>
        </div>
        <br />

        <br />

        <!-- Precast Comments -->
        <div
          class="col-11 b3 b4"
          >
          <mat-label class="mat-label">Comments</mat-label>
          <div class="c-w">
            <app-richtext-editor formControlName="commentPart1" minHeight="80px"></app-richtext-editor>
          </div>
        </div>

        <br />

        <!-- Signature -->
        <div class="col-11">
          <mat-label class="mat-label">Signature</mat-label>
          <mat-form-field appearance="outline" class="col-2">
            <mat-select disableOptionCentering formControlName="signatureTypeId" placeholder="Select" [compareWith]="compareSignatureIds">
              <mat-option value="C063AD0D-903F-447B-BCCC-A3C014CFAD7E" class="arrow">Nimesh Patel</mat-option>
              <mat-option value="98FAE02D-953F-4ADB-9794-575A0882A5A3" class="arrow">Deepak Parmar</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <!-- Units of Measurement -->
        <div class="col-11">
          <mat-label class="mat-label">Units of Measurement</mat-label>
          <div class="radio-button-container">
            <mat-radio-group formControlName="isMetricUnit">
              <mat-radio-button value="Imperial">Imperial</mat-radio-button>
              <mat-radio-button value="Metric">Metric</mat-radio-button>
            </mat-radio-group>
          </div>
        </div>

        <!-- Buttons -->
        <div class="button-wrapper">
          <mat-checkbox
            class="show-points-checkbox"
            [(ngModel)]="showPoints"
            [ngModelOptions]="{ standalone: true }">
            Show Points
          </mat-checkbox>
          <button mat-raised-button [disabled]="previewDisabled" (click)="preview()">DOWNLOAD WORD</button>
          <button mat-raised-button [disabled]="previewPdfDisabled" (click)="previewPdf()">PREVIEW PDF</button>
          <button mat-raised-button color="primary" (click)="save()" [disabled]="!form.dirty">SAVE</button>
        </div>
      </div>
    </form>
  </div>

  <!-- ═══════════ Figures Card ═══════════ -->
  <div class="edit-report-wrapper mat-elevation-z1">
    <h1>Figures</h1>
    @if (previewData) {
      <p>Date Modified: {{ formatDate(previewData.updatedAt) }}</p>
    }
    <div class="e-button-wrapper">
      <button mat-raised-button color="primary" (click)="editFigures()">EDIT</button>
    </div>
  </div>
